import {Personal} from "./personal/personal";
import {Password} from "./password/password";
import {Avatar} from "./avatar/avatar";
import {Notifications} from "./notifications/notifications";
import {ResetPassword} from "./reset-password/reset-password";

const personalCabinet = () => {
  if (document.querySelector(`.js-profile`)) {
    try {
      new Personal(`.js-personal-data`).init();
      new Password(`.js-password-form`).init();
      new Avatar(`.js-avatar-form`).init();
      new Notifications(`.js-notification-form`).init();
      new ResetPassword().init();
    } catch (e) {
      console.error(e);
    }
  }
};

export {personalCabinet};
